import Head from "next/head";
import { generateTitle, formatKeywords } from "@/utils/seo-utils";

export interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string[];
  canonical?: string;
  noindex?: boolean;
  siteName?: string;
  structuredData?: Record<string, any> | Record<string, any>[];
}

export const SEO: React.FC<SEOProps> = ({
  title,
  description,
  keywords,
  canonical,
  noindex = false,
  siteName,
}) => {
  const fullTitle = generateTitle(title, siteName);
  const keywordsString = formatKeywords(keywords);

  return (
    <Head>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      {keywordsString && <meta name="keywords" content={keywordsString} />}
      {canonical && <link rel="canonical" href={canonical} />}
      {noindex && <meta name="robots" content="noindex,nofollow" />}
    </Head>
  );
};

export default SEO;
